import React, { useEffect } from "react";
import { X } from "lucide-react";
import BlogPost from "./BlogPost";

interface BlogPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  slug: string;
}

export default function BlogPreviewModal({
  isOpen,
  onClose,
  slug,
}: BlogPreviewModalProps) {
  // Set localStorage when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      localStorage.setItem("previewModalOpen", "true");
    } else {
      localStorage.removeItem("previewModalOpen");
    }
    // Dispatch storage event to notify other components
    window.dispatchEvent(
      new StorageEvent("storage", {
        key: "previewModalOpen",
        newValue: isOpen ? "true" : null,
      }),
    );

    // Prevent body scroll when modal is open
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-[9999] overflow-y-auto"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="min-h-screen px-4 text-center">
        {/* Close button */}
        <div className="fixed top-4 right-4 z-[10000]">
          <button
            onClick={onClose}
            className="bg-white rounded-full p-2 hover:bg-gray-100 transition-colors duration-200 shadow-lg"
          >
            <X className="h-6 w-6 text-gray-600" />
          </button>
        </div>

        {/* Modal content */}
        <div className="inline-block w-full max-w-6xl my-8 text-left align-middle">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <BlogPost previewMode={true} slug={slug} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
